
<template>
  <HqDrawer  title="审核记录" :visible.sync="showVissible" ref="drawer" size="70%">
      <div class="drawer-body">
        <div class="goods-table-wrapper">
          <!-- 记录表格区 -->
          <el-table
            style="width: 100%;margin-bottom:24px"
            border
            stripe
            size="mini"
            element-loading-text="拼命加载中"
            :header-cell-style="{ background: '#e5f2ff' }"
            sortable
            highlight-current-row
            header-cell-class-name="normal-table-header"
            :data="tableData"
            :row-key="(row) => row.orderId"
              ref="multipleTable"
          >
            <template v-for="item of columns">
              <el-table-column :show-overflow-tooltip="true" v-if="item.prop === 'createTime'" :label="item.label" :key="item.prop" min-width="160px">
                <template v-slot:default="{ row }">
                  {{ row.createTime | formatDate('YYYY-MM-DD HH:mm:ss')}}
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" v-else-if="item.prop === 'status'" :key="item.prop" :label="item.label" min-width="120px">
                <template slot-scope="scope">
                   {{scope.row.status==5 ? '发起审批' : (scope.row.status==1 ? '审批通过' : (scope.row.status==7 ? '审批通过': (scope.row.status==2 ? '审批拒绝' : (scope.row.status==3 ? '审批撤销' : '')))) }}
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" v-else-if="item.prop === 'submitId'" :key="item.prop" :label="item.label" min-width="100px">
                <template v-slot:default="{ row }">
                  <span v-if="row.submitId === ''">- -</span>
                  <span v-else>{{row.submitId}}</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true"
                v-else
                :key="item.label"
                :label="item.label"
                :prop="item.prop"
                :fixed="item.fixed"
                :min-width="item.width || '200px'"
              >
                <template v-slot:default="{ row }">
                  <span v-if="['remark'].includes(item.prop)">{{ row[item.prop] | empty('- -')}}</span>
                  <span v-else>{{row[item.prop]}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>

          <!-- <div class="page_test_bottom">
            <el-pagination
              background
              @size-change="pageChange"
              @current-change="pageSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalCount"
            />
          </div> -->
        </div>
      </div>
      
      <div slot="footer">
        <el-button @click="onCancel">返回</el-button>
      </div>
  </HqDrawer>
</template>

<script>
import axios from "axios";

export default {
  name: "CheckHistory",
  props: {
    visible: Boolean,
    aftersaleType: [Number, String],
    reviewData: Object,
    orderModalRules: Object,
    orderModalItems: Array,
    selectMode: String
  },
  data() {
    return {
      showVissible: this.visible,
      currentRadioIndex: "",
      tableData: [],
      columns: [
        { label: "审批单号", prop: "employmentId", width: "120px", fixed: true },
        { label: "审核状态", prop: "status",width: "120px", fixed: true  },
        { label: "审核人", prop: "submitId",  },
        { label: "审核时间", prop: "createTime", width: "120px" },
        { label: "审核意见", prop: "remark", width: "170px" },
      ],
      page: 1,
      pageSize: 10,
      totalPage: 1,
      totalCount: 1,
      goodsCateModalVisible: false,
      selectRows: [],
      id: '',
      processInstanceId: ''
    }
  },
  methods: {
    init(row) {
      this.$refs.drawer.init()
      this.id = row.id
      this.processInstanceId = row.processInstanceId ? row.processInstanceId : ''
      this.getTableData()
    },
    onCancel() {
      this.$refs.drawer.close()
    },
    // pageChange(val) {
    //   this.curPage = val
    //   this.getTableData()
    // },
    // pageSizeChange(val) {
    //   this.pageSize = val;
    //   this.getTableData()
    // },

    // 获取订单列表表格数据
    async getTableData() {
      this.tableData = []
      const params = {
        employmentId: this.id,
        // curPage: this.page,
        // pageSize: this.pageSize,
      }
      const res = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/details`, params,{
        headers:{
          "CrmToken": localStorage.getItem("userToken")
        }
      }).then((res) => res.data)
      console.log('res', res);
      if(res.code == 200) {
        this.tableData = res.data && res.data.list ? res.data.list : []
        // this.totalPage = res.data.total
        // this.totalCount = res.data.total
      } else {
        this.$message.error(res.msg)
      }
      
    },
  },
  computed: {
  },
  watch: {
    visible: {
      handler(visible) {
        this.showVissible = visible;
        if (!visible) return
        this.getTableData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-table-wrapper {
    // width: 100%;
    width: 94%;
    margin: 0 auto;
    // margin-bottom: 44px;
    // padding: 0 30px;
    // margin-top: 10px;
  }
.drawer-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 100;
  background: rgba($color: #000000, $alpha: 0.6);
  .drawer-container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    .drawer-content {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      width: 72%;
      height: 100%;
      background: #fff;
      box-shadow: -6px 0px 10px 0px rgba(112, 112, 112, 0.12);
      .drawer-header {
        display: flex;
        width: 100%;
        height: 60px;
        line-height: 60px;
        padding: 0 30px;

        > h2 {
          color: #333;
          font-size: 16px;
          font-weight: 700;
        }
      }
      .drawer-body {
        flex: 1;
        border-top: 1px solid #e1e4eb;
        border-bottom: 1px solid #e1e4eb;
        overflow: auto;
        .goods-form-wrapper {
          margin: 30px 0 0px 0;
          padding: 0 25px;
          .formContent{
            display: flex;
            flex-wrap: wrap;
          }
          .searchItem{
            display: flex;
            width: 300px;
          }
          ::v-deep .el-input__suffix {
            right: 12px;
          }
        }
        .actions-btn {
          padding-left: 68px;
        }
        .goods-table-wrapper {
          // width: 100%;
          width: 94%;
          margin: 0 auto;
          // margin-bottom: 44px;
          // padding: 0 30px;
          // margin-top: 10px;
          .el-radio__label{
            display: none;
          }
        }
      }
      
    }
  }
}
.drawer-footer {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // width: 100%;
  // height: 90px;
  position: absolute;
  bottom: 24px;
  left: 0;
  text-align: center;
  width: 100%;
}
.drawer-enter-active,
.drawer-leave-active {
  transition: 0.3s;
}
.drawer-enter {
  transform: translate(100%);
}
.drawer-leave-to {
  transform: translate(100%);
}
</style>
